// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__8PL27","row":"Layout_row__oh8Tj","col":"Layout_col__aXofR"};